import React from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import {addSlash} from '../../utils/urlUtils';

export const getPages = (match, pageInfos) =>
  pageInfos.map(page => ({
    path: `${addSlash(match.path)}${page.slug}`,
    url: `${addSlash(match.url)}${page.slug}`,
    ...page,
  }));

const DefaultNavigation = ({user, pages, defaultPageIndex = 0}) => (
  <Switch>
    {pages.map(({path, component: Component, slug}) => (
      <Route key={slug} path={path} render={props => <Component {...props} slug={slug} user={user} />} />
    ))}
    <Redirect to={pages[defaultPageIndex].url} />
  </Switch>
);

export default DefaultNavigation;
